export default __webpack_public_path__ + "b31b3d36f654ad46d96bee3693426c7e.jpg";